<template>
    <div class="main-div">
        <el-row class="main-title" style="width:100%;">
            <label>{{ machine?.name }}</label>
        </el-row>
        <el-row class="linechart" style="width:100%;">
            <el-col :span="12">
                <AchievementLineChart
                    :data="rates" :labels="labels" :title="title"
                    style="height: 100%; width:100%;" />
            </el-col>
            <el-col :span="12">
                <ProduceRatioLine
                    :data="line2data" :labels="line2labels" :title="'xx'"
                    style="height: 100%; width:100%;" />
            </el-col>
        </el-row>
        <el-row class="datagrid">
            <data-grid :data="data" />
        </el-row>
    </div>
</template>
<script>
import {notify} from '../../assets/js/utils.js';
import UserStore from '../../stores/user.js';
import ProduceRatioLine from './produce-ratio-line.vue';
import AchievementLineChart from './achievement-line.vue';
import DataGrid from './achievement-grid.vue';
import {Chart, registerables} from 'chart.js';
import {try_catch} from '../../assets/js/async.js';
Chart.register(...registerables);

export default {
    name: 'TaskList',
    components: {
        AchievementLineChart,
        ProduceRatioLine,
        DataGrid,
    },
    data() {
        return {
            args: {
                corp: '',
                query: '',
            },
            data: [],
            machine: {},
            title: '',
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        rates() {
            return this.data.map(x => x.achievement_rate).reverse();
        },
        labels() {
            return this.data.map(x => x.planned_date).reverse();
        },
        line2labels() {
            return this.data.filter(x => !isNaN(x.produce_ratio)).map(x => x.planned_date).reverse();
        },
        line2data() {
            return this.data.filter(x => !isNaN(x.produce_ratio)).map(x => x.produce_ratio).reverse();
        },
    },
    mounted() {

    },
    beforeMount() {
        this.load_data();
    },
    methods: {
        async load_data() {
            const mid = this.$route.params.mid ?? this.$route.query.mid;
            const token = this.$route.query.token;
            const url = token ? '/api/achievement' : `/api/achievement/${mid}`;
            const params = token ? {mid, token} : null;
            await try_catch(async () => {
                const res = await this.axios.get(url, {params});
                if (res.data.code && res.data.error) {
                    notify('warning', `未登录！`);
                    return;
                }
                const machine = res.data.machine;
                console.log(machine);
                console.log(res.data.data);
                const data = res.data.data.map(x => {
                    return {
                        ...x,
                        speed: Math.round(x.quantity_total / x.produce_duration / 60),
                        stoptime: Math.round((x.runtime - x.produce_duration) * 10) / 10,
                        produce_ratio: Math.round(
                            x.produce_duration / x.runtime * 100 * 10,
                        ) / 10,
                    };
                });

                this.data.length = 0;
                this.data.push(...data);
                Object.entries(machine).forEach(([k, v]) => {
                    this.machine[k] = v;
                });
                this.title = machine.name;
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
}
.main-title {
    text-align: center;
    justify-content: center;
    font-weight: bold;
}
.linechart {
  flex: 0 0 auto; /* 不会伸缩，固定高度 */
  height: 30%; /* 高度占主容器的 30% */
  min-height: 100px; /* 最小高度 */
  max-height: 300px; /* 最大高度 */
}
.datagrid {
    height: 100px;
    flex-grow: 1;
}
</style>
